import React from "react";
import { CURRENCY } from "@core/utils/consts";
import { useParams } from "react-router-dom";
import { TVChartContainer } from "../TVChartContainer";
import { useTheme } from "@material-ui/core";
import { useMarkets } from "@context/marketsContext";
import { getExchangeSlug } from "@core/utils";

/** TradingView symbol: known const or `{BASE}{QUOTE}` (e.g. BTCUSDT, BTCCAD). */
function resolveChartSymbol(base, quote, getMarketByRoute) {
  const fromCatalog = getMarketByRoute(`${base}-${quote}`);
  if (fromCatalog?.symbol) {
    return fromCatalog.symbol;
  }
  const fromConst = CURRENCY?.TYPE[base]?.SYMBOLS?.[quote];
  if (fromConst) {
    return fromConst;
  }
  if (base && quote) {
    return `${base}${quote}`;
  }
  return undefined;
}

const MarketChart = () => {
  const { currencyName } = useParams();
  const firstCurrency = currencyName?.split("-")[0];
  const secondCurrency = currencyName?.split("-")[1];
  const theme = useTheme();
  const { getMarketByRoute } = useMarkets();

  if (!firstCurrency || !secondCurrency) {
    return null;
  }

  const ticker = resolveChartSymbol(
    firstCurrency,
    secondCurrency,
    getMarketByRoute
  );

  if (!ticker) {
    return null;
  }

  // Pass exchange-prefixed symbol so TV resolve/getBars always parse cleanly.
  const symbol = `${getExchangeSlug()}:${ticker}`;

  return (
    <TVChartContainer theme={theme.palette.type} symbol={symbol} />
  );
};

export default MarketChart;
